var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5897 8.9799H17.5935L15.486 7.1774C15.2897 7.00865 15.2535 6.71865 15.4035 6.5074L16.6885 4.6974C17.1585 4.0349 16.6847 3.11865 15.8735 3.11865H8.12723C7.31473 3.11865 6.84223 4.0349 7.31223 4.6974L8.59723 6.5074C8.74723 6.71865 8.71098 7.00865 8.51473 7.1774L6.40723 8.9799H6.41098C4.62848 10.5374 3.50098 12.8274 3.50098 15.3812V16.8812C3.50098 19.0899 5.29223 20.8812 7.50098 20.8812H16.501C18.7097 20.8812 20.501 19.0899 20.501 16.8812V15.3812C20.501 12.8274 19.3735 10.5387 17.591 8.9799H17.5897Z",
    fill: "#FFC22A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8745 12.3794L13.4995 16.8794L11.9995 12.3794L10.4995 16.8794L9.12451 12.3794",
    stroke: "white",
    strokeWidth: 1.83316,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.187 14.6294H15.4995",
    stroke: "white",
    strokeWidth: 1.83316,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49951 14.6294H9.81201",
    stroke: "white",
    strokeWidth: 1.83316,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoney);
export default __webpack_public_path__ + "static/media/icon_money.496e8488.svg";
export { ForwardRef as ReactComponent };